
import Vue from 'vue'

const locales = {keys(){return []}}
global['____826D0CB____'] = true;
delete global['____826D0CB____'];
global.__uniConfig = {"easycom":{"^u-(.*)":"@/uview-ui/components/u-$1/u-$1.vue","^com-(.*)":"@/components/common/com-$1.vue","^diy-(.*)":"@/components/diy/diy-$1.vue","^unicloud-db$":"@dcloudio/uni-cli-shared/components/unicloud-db.vue","^uniad$":"@dcloudio/uni-cli-shared/components/uniad.vue","^ad-rewarded-video$":"@dcloudio/uni-cli-shared/components/ad-rewarded-video.vue","^ad-fullscreen-video$":"@dcloudio/uni-cli-shared/components/ad-fullscreen-video.vue","^ad-interstitial$":"@dcloudio/uni-cli-shared/components/ad-interstitial.vue","^ad-interactive$":"@dcloudio/uni-cli-shared/components/ad-interactive.vue","^page-meta$":"@dcloudio/uni-cli-shared/components/page-meta.vue","^navigation-bar$":"@dcloudio/uni-cli-shared/components/navigation-bar.vue","^uni-match-media$":"@dcloudio/uni-cli-shared/components/uni-match-media.vue"},"globalStyle":{"navigationBarTextStyle":"black","navigationBarBackgroundColor":"#F8F8F8","backgroundColor":"#F8F8F8"}};
global.__uniConfig.compilerVersion = '4.76';
global.__uniConfig.darkmode = false;
global.__uniConfig.themeConfig = {};
global.__uniConfig.uniPlatform = 'h5';
global.__uniConfig.appId = '__UNI__826D0CB';
global.__uniConfig.appName = ' ';
global.__uniConfig.appVersion = '1.0.0';
global.__uniConfig.appVersionCode = '100';
global.__uniConfig.router = {"mode":"hash","base":"./"};
global.__uniConfig.publicPath = "/";
global.__uniConfig['async'] = {"loading":"AsyncLoading","error":"AsyncError","delay":200,"timeout":60000};
global.__uniConfig.debug = false;
global.__uniConfig.networkTimeout = {"request":60000,"connectSocket":60000,"uploadFile":60000,"downloadFile":60000};
global.__uniConfig.sdkConfigs = {"maps":{"qqmap":{"key":"CAFBZ-X2C3D-GL44M-P2PUY-5Q6ZE-WYBZR"}}};
global.__uniConfig.qqMapKey = "CAFBZ-X2C3D-GL44M-P2PUY-5Q6ZE-WYBZR";
global.__uniConfig.googleMapKey = undefined;
global.__uniConfig.aMapKey = undefined;
global.__uniConfig.aMapSecurityJsCode = undefined;
global.__uniConfig.aMapServiceHost = undefined;
global.__uniConfig.locale = "";
global.__uniConfig.fallbackLocale = undefined;
global.__uniConfig.locales = locales.keys().reduce((res,key)=>{const locale=key.replace(/\.\/(uni-app.)?(.*).json/,'$2');const messages = locales(key);Object.assign(res[locale]||(res[locale]={}),messages.common||messages);return res},{});
global.__uniConfig.nvue = {"flex-direction":"column"}
global.__uniConfig.__webpack_chunk_load__ = __webpack_chunk_load__
Vue.component('pages-iframe-iframe', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/pages/iframe/iframe"+'.vue')), 'pages-iframe-iframe'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/pages/index/index"+'.vue')), 'pages-index-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-index-webView', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/pages/index/webView"+'.vue')), 'pages-index-webView'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-search-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/pages/search/index"+'.vue')), 'pages-search-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-login', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/pages/public/login"+'.vue')), 'pages-public-login'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-registered', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/pages/public/registered"+'.vue')), 'pages-public-registered'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-forget', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/pages/public/forget"+'.vue')), 'pages-public-forget'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-public-bindPhone', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/pages/public/bindPhone"+'.vue')), 'pages-public-bindPhone'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('pages-menu-index', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/pages/menu/index"+'.vue')), 'pages-menu-index'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('uview-ui-components-u-avatar-cropper-u-avatar-cropper', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/uview-ui/components/u-avatar-cropper/u-avatar-cropper"+'.vue')), 'uview-ui-components-u-avatar-cropper-u-avatar-cropper'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins-pages-privacyPolicy-privacyPolicy', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins/pages/privacyPolicy/privacyPolicy"+'.vue')), 'plugins-pages-privacyPolicy-privacyPolicy'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins-pages-settings-userInfo', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins/pages/settings/userInfo"+'.vue')), 'plugins-pages-settings-userInfo'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins-pages-settings-paypass', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins/pages/settings/paypass"+'.vue')), 'plugins-pages-settings-paypass'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins-pages-settings-loginpaypass', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins/pages/settings/loginpaypass"+'.vue')), 'plugins-pages-settings-loginpaypass'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins-pages-settings-setting', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins/pages/settings/setting"+'.vue')), 'plugins-pages-settings-setting'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins-pages-settings-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins/pages/settings/address"+'.vue')), 'plugins-pages-settings-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins-pages-settings-edit-address', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins/pages/settings/edit-address"+'.vue')), 'plugins-pages-settings-edit-address'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins-pages-settings-appStyle', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins/pages/settings/appStyle"+'.vue')), 'plugins-pages-settings-appStyle'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-diy-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/diy/list"+'.vue')), 'plugins1-diy-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-diy-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/diy/detail"+'.vue')), 'plugins1-diy-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-diy-them', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/diy/them"+'.vue')), 'plugins1-diy-them'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template1-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template1/detail"+'.vue')), 'plugins1-template1-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template1-connect', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template1/connect"+'.vue')), 'plugins1-template1-connect'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template1-message', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template1/message"+'.vue')), 'plugins1-template1-message'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template1-catelist', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template1/catelist"+'.vue')), 'plugins1-template1-catelist'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template1-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template1/list"+'.vue')), 'plugins1-template1-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template1-catedetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template1/catedetail"+'.vue')), 'plugins1-template1-catedetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template2-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template2/detail"+'.vue')), 'plugins1-template2-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template2-message', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template2/message"+'.vue')), 'plugins1-template2-message'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template2-catelist', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template2/catelist"+'.vue')), 'plugins1-template2-catelist'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template2-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template2/list"+'.vue')), 'plugins1-template2-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template2-catedetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template2/catedetail"+'.vue')), 'plugins1-template2-catedetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template5-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template5/detail"+'.vue')), 'plugins1-template5-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template5-message', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template5/message"+'.vue')), 'plugins1-template5-message'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template5-catelist', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template5/catelist"+'.vue')), 'plugins1-template5-catelist'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template5-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template5/list"+'.vue')), 'plugins1-template5-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template5-catedetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template5/catedetail"+'.vue')), 'plugins1-template5-catedetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template3-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template3/detail"+'.vue')), 'plugins1-template3-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template3-connect', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template3/connect"+'.vue')), 'plugins1-template3-connect'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template3-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template3/list"+'.vue')), 'plugins1-template3-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template3-getconnect', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template3/getconnect"+'.vue')), 'plugins1-template3-getconnect'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template3-catedetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template3/catedetail"+'.vue')), 'plugins1-template3-catedetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template4-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template4/detail"+'.vue')), 'plugins1-template4-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template4-message', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template4/message"+'.vue')), 'plugins1-template4-message'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template4-catelist', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template4/catelist"+'.vue')), 'plugins1-template4-catelist'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template4-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template4/list"+'.vue')), 'plugins1-template4-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template4-catedetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template4/catedetail"+'.vue')), 'plugins1-template4-catedetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template6-detail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template6/detail"+'.vue')), 'plugins1-template6-detail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template6-message', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template6/message"+'.vue')), 'plugins1-template6-message'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template6-catelist', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template6/catelist"+'.vue')), 'plugins1-template6-catelist'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template6-list', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template6/list"+'.vue')), 'plugins1-template6-list'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template6-device', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template6/device"+'.vue')), 'plugins1-template6-device'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template6-plan', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template6/plan"+'.vue')), 'plugins1-template6-plan'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template6-my', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template6/my"+'.vue')), 'plugins1-template6-my'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template6-catedetail', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template6/catedetail"+'.vue')), 'plugins1-template6-catedetail'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template6-loginpaypass', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template6/loginpaypass"+'.vue')), 'plugins1-template6-loginpaypass'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
Vue.component('plugins1-template6-setting', resolve=>{
const component = {
  component:require.ensure([], () => resolve(require("C:/php/phpstudy_pro/WWW/x-e/plugins1/template6/setting"+'.vue')), 'plugins1-template6-setting'),
  delay:__uniConfig['async'].delay,
  timeout: __uniConfig['async'].timeout
}
if(__uniConfig['async']['loading']){
  component.loading={
    name:'SystemAsyncLoading',
    render(createElement){
      return createElement(__uniConfig['async']['loading'])
    }
  }
}
if(__uniConfig['async']['error']){
  component.error={
    name:'SystemAsyncError',
    render(createElement){
      return createElement(__uniConfig['async']['error'])
    }
  }
}
return component
})
global.__uniRoutes=[
{
path: '/',
alias:'/pages/iframe/iframe',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          isQuit:true,
isEntry:true,

          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-iframe-iframe', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
id:1,
  name:'pages-iframe-iframe',
  isNVue:false,maxWidth:0,
  pagePath:'pages/iframe/iframe',
isQuit:true,
isEntry:true,
  windowTop:0
}
},
{
path: '/pages/index/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-index-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/index',
  windowTop:0
}
},
{
path: '/pages/index/webView',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('pages-index-webView', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-index-webView',
  isNVue:false,maxWidth:0,
  pagePath:'pages/index/webView',
  windowTop:0
}
},
{
path: '/pages/search/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"搜索","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#FFFFFF","backgroundColorBottom":"#FFFFFF"})
      },
      [
        createElement('pages-search-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-search-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/search/index',
  windowTop:44
}
},
{
path: '/pages/public/login',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"登录","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-public-login', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-login',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/login',
  windowTop:44
}
},
{
path: '/pages/public/registered',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"注册","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-public-registered', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-registered',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/registered',
  windowTop:44
}
},
{
path: '/pages/public/forget',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"忘记密码","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-public-forget', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-forget',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/forget',
  windowTop:44
}
},
{
path: '/pages/public/bindPhone',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"绑定手机号","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black"})
      },
      [
        createElement('pages-public-bindPhone', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-public-bindPhone',
  isNVue:false,maxWidth:0,
  pagePath:'pages/public/bindPhone',
  windowTop:44
}
},
{
path: '/pages/menu/index',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"","navigationStyle":"custom","enablePullDownRefresh":false})
      },
      [
        createElement('pages-menu-index', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'pages-menu-index',
  isNVue:false,maxWidth:0,
  pagePath:'pages/menu/index',
  windowTop:0
}
},
{
path: '/uview-ui/components/u-avatar-cropper/u-avatar-cropper',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"头像裁剪","navigationBarBackgroundColor":"#000000"})
      },
      [
        createElement('uview-ui-components-u-avatar-cropper-u-avatar-cropper', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'uview-ui-components-u-avatar-cropper-u-avatar-cropper',
  isNVue:false,maxWidth:0,
  pagePath:'uview-ui/components/u-avatar-cropper/u-avatar-cropper',
  windowTop:44
}
},
{
path: '/plugins/pages/privacyPolicy/privacyPolicy',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"隐私政策/用户协议","navigationBarBackgroundColor":"#fff","navigationBarTextStyle":"black"})
      },
      [
        createElement('plugins-pages-privacyPolicy-privacyPolicy', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins-pages-privacyPolicy-privacyPolicy',
  isNVue:false,maxWidth:0,
  pagePath:'plugins/pages/privacyPolicy/privacyPolicy',
  windowTop:44
}
},
{
path: '/plugins/pages/settings/userInfo',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"个人资料","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#FFFFFF","backgroundColorBottom":"#FFFFFF"})
      },
      [
        createElement('plugins-pages-settings-userInfo', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins-pages-settings-userInfo',
  isNVue:false,maxWidth:0,
  pagePath:'plugins/pages/settings/userInfo',
  windowTop:0
}
},
{
path: '/plugins/pages/settings/paypass',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"支付密码","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#FFFFFF","backgroundColorBottom":"#FFFFFF"})
      },
      [
        createElement('plugins-pages-settings-paypass', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins-pages-settings-paypass',
  isNVue:false,maxWidth:0,
  pagePath:'plugins/pages/settings/paypass',
  windowTop:0
}
},
{
path: '/plugins/pages/settings/loginpaypass',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"登录密码","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#FFFFFF","backgroundColorBottom":"#FFFFFF"})
      },
      [
        createElement('plugins-pages-settings-loginpaypass', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins-pages-settings-loginpaypass',
  isNVue:false,maxWidth:0,
  pagePath:'plugins/pages/settings/loginpaypass',
  windowTop:0
}
},
{
path: '/plugins/pages/settings/setting',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"设置","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#FFFFFF","backgroundColorBottom":"#FFFFFF"})
      },
      [
        createElement('plugins-pages-settings-setting', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins-pages-settings-setting',
  isNVue:false,maxWidth:0,
  pagePath:'plugins/pages/settings/setting',
  windowTop:0
}
},
{
path: '/plugins/pages/settings/address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"地址","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#FFFFFF","backgroundColorBottom":"#FFFFFF"})
      },
      [
        createElement('plugins-pages-settings-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins-pages-settings-address',
  isNVue:false,maxWidth:0,
  pagePath:'plugins/pages/settings/address',
  windowTop:0
}
},
{
path: '/plugins/pages/settings/edit-address',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"编辑地址","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#FFFFFF","backgroundColorBottom":"#FFFFFF"})
      },
      [
        createElement('plugins-pages-settings-edit-address', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins-pages-settings-edit-address',
  isNVue:false,maxWidth:0,
  pagePath:'plugins/pages/settings/edit-address',
  windowTop:0
}
},
{
path: '/plugins/pages/settings/appStyle',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarTitleText":"切换主题","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#FFFFFF","backgroundColorBottom":"#FFFFFF"})
      },
      [
        createElement('plugins-pages-settings-appStyle', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins-pages-settings-appStyle',
  isNVue:false,maxWidth:0,
  pagePath:'plugins/pages/settings/appStyle',
  windowTop:44
}
},
{
path: '/plugins1/diy/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-diy-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-diy-list',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/diy/list',
  windowTop:44
}
},
{
path: '/plugins1/diy/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-diy-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-diy-detail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/diy/detail',
  windowTop:44
}
},
{
path: '/plugins1/diy/them',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-diy-them', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-diy-them',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/diy/them',
  windowTop:44
}
},
{
path: '/plugins1/template1/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template1-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template1-detail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template1/detail',
  windowTop:0
}
},
{
path: '/plugins1/template1/connect',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template1-connect', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template1-connect',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template1/connect',
  windowTop:0
}
},
{
path: '/plugins1/template1/message',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template1-message', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template1-message',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template1/message',
  windowTop:0
}
},
{
path: '/plugins1/template1/catelist',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template1-catelist', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template1-catelist',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template1/catelist',
  windowTop:0
}
},
{
path: '/plugins1/template1/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template1-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template1-list',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template1/list',
  windowTop:0
}
},
{
path: '/plugins1/template1/catedetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template1-catedetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template1-catedetail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template1/catedetail',
  windowTop:0
}
},
{
path: '/plugins1/template2/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationStyle":"custom","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-template2-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template2-detail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template2/detail',
  windowTop:0
}
},
{
path: '/plugins1/template2/message',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationStyle":"custom","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-template2-message', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template2-message',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template2/message',
  windowTop:0
}
},
{
path: '/plugins1/template2/catelist',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationStyle":"custom","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-template2-catelist', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template2-catelist',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template2/catelist',
  windowTop:0
}
},
{
path: '/plugins1/template2/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationStyle":"custom","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-template2-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template2-list',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template2/list',
  windowTop:0
}
},
{
path: '/plugins1/template2/catedetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationStyle":"custom","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-template2-catedetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template2-catedetail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template2/catedetail',
  windowTop:0
}
},
{
path: '/plugins1/template5/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationStyle":"custom","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-template5-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template5-detail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template5/detail',
  windowTop:0
}
},
{
path: '/plugins1/template5/message',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationStyle":"custom","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-template5-message', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template5-message',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template5/message',
  windowTop:0
}
},
{
path: '/plugins1/template5/catelist',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-template5-catelist', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template5-catelist',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template5/catelist',
  windowTop:44
}
},
{
path: '/plugins1/template5/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationBarBackgroundColor":"#FFFFFF","navigationStyle":"custom","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-template5-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template5-list',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template5/list',
  windowTop:0
}
},
{
path: '/plugins1/template5/catedetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#F7F7F7","backgroundColorBottom":"#F7F7F7","navigationBarTitleText":""})
      },
      [
        createElement('plugins1-template5-catedetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template5-catedetail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template5/catedetail',
  windowTop:0
}
},
{
path: '/plugins1/template3/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template3-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template3-detail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template3/detail',
  windowTop:0
}
},
{
path: '/plugins1/template3/connect',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template3-connect', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template3-connect',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template3/connect',
  windowTop:0
}
},
{
path: '/plugins1/template3/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template3-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template3-list',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template3/list',
  windowTop:0
}
},
{
path: '/plugins1/template3/getconnect',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template3-getconnect', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template3-getconnect',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template3/getconnect',
  windowTop:0
}
},
{
path: '/plugins1/template3/catedetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template3-catedetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template3-catedetail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template3/catedetail',
  windowTop:0
}
},
{
path: '/plugins1/template4/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template4-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template4-detail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template4/detail',
  windowTop:0
}
},
{
path: '/plugins1/template4/message',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template4-message', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template4-message',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template4/message',
  windowTop:0
}
},
{
path: '/plugins1/template4/catelist',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template4-catelist', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template4-catelist',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template4/catelist',
  windowTop:0
}
},
{
path: '/plugins1/template4/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template4-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template4-list',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template4/list',
  windowTop:0
}
},
{
path: '/plugins1/template4/catedetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template4-catedetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template4-catedetail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template4/catedetail',
  windowTop:0
}
},
{
path: '/plugins1/template6/detail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template6-detail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template6-detail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template6/detail',
  windowTop:0
}
},
{
path: '/plugins1/template6/message',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template6-message', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template6-message',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template6/message',
  windowTop:0
}
},
{
path: '/plugins1/template6/catelist',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template6-catelist', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template6-catelist',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template6/catelist',
  windowTop:0
}
},
{
path: '/plugins1/template6/list',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template6-list', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template6-list',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template6/list',
  windowTop:0
}
},
{
path: '/plugins1/template6/device',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template6-device', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template6-device',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template6/device',
  windowTop:0
}
},
{
path: '/plugins1/template6/plan',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template6-plan', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template6-plan',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template6/plan',
  windowTop:0
}
},
{
path: '/plugins1/template6/my',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template6-my', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template6-my',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template6/my',
  windowTop:0
}
},
{
path: '/plugins1/template6/catedetail',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","titleNView":false})
      },
      [
        createElement('plugins1-template6-catedetail', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template6-catedetail',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template6/catedetail',
  windowTop:0
}
},
{
path: '/plugins1/template6/loginpaypass',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"登录密码","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#FFFFFF","backgroundColorBottom":"#FFFFFF"})
      },
      [
        createElement('plugins1-template6-loginpaypass', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template6-loginpaypass',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template6/loginpaypass',
  windowTop:0
}
},
{
path: '/plugins1/template6/setting',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props: Object.assign({
          
          
          
        },__uniConfig.globalStyle,{"navigationStyle":"custom","navigationBarTitleText":"设置","navigationBarBackgroundColor":"#FFFFFF","navigationBarTextStyle":"black","backgroundColorTop":"#FFFFFF","backgroundColorBottom":"#FFFFFF"})
      },
      [
        createElement('plugins1-template6-setting', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'plugins1-template6-setting',
  isNVue:false,maxWidth:0,
  pagePath:'plugins1/template6/setting',
  windowTop:0
}
},
{
path: '/choose-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-choose-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'choose-location',
  pagePath:'/choose-location'
}
}
    ,
{
path: '/open-location',
component: {
  render (createElement) {
    return createElement(
      'Page',
      {
        props:{
          navigationStyle:'custom'
        }
      },
      [
        createElement('system-open-location', {
          slot: 'page'
        })
      ]
    )
  }
},
meta:{
  name:'open-location',
  pagePath:'/open-location'
}
}
    ]
global.UniApp && new global.UniApp();
